import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { cn, formatLessThan10 } from "@/lib/utils";
import { Add, ArrowDown2, Send2 } from "iconsax-react";
import React, { FC, useState } from "react";
import { typesFilters } from "../dummy-resources";
import AssignedResourceItem from "./assigned-resource-item";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MassiveUpload: FC<Props> = ({ isOpen, setIsOpen }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [resources, setResources] = useState<any[]>([]);
  const [formError, setFormError] = useState<any>({});

  const closeDrawer = () => {
    setIsOpen(false);
  };

  const getSelectedType = () => {
    const index = typesFilters.findIndex((item) => item.id === selectedType);
    if (index == -1) return "Selecciona";
    return typesFilters[index].title;
  };

  const addResource = () => {
    setResources([...resources, ""]);
  };

  return (
    <Sheet open={isOpen} onOpenChange={closeDrawer}>
      <SheetContent
        className="flex w-[450px] flex-col gap-0 [&>button]:hidden"
        style={{ maxWidth: "50vw" }}
      >
        <SheetHeader>
          <SheetTitle>Subida masiva</SheetTitle>
        </SheetHeader>
        <SheetBody className="h-full overflow-y-scroll p-0">
          <div className="flex h-full flex-col justify-between">
            <div className="flex flex-1 flex-col gap-2 overflow-y-scroll p-6">
              <div className="mb-4 rounded-lg border border-[#615CB7] px-4 py-5">
                <div className="flex items-center gap-2">
                  <Send2 size="22" color="#615CB7" />
                  <p className="flex-1 text-base">Recuerda que...</p>
                </div>
                <div className="flex items-center gap-2">
                  <Send2 size="22" color="transparent" />
                  <p className="mt-2 flex-1 text-sm">
                    Si subes archivos, estos deben pesar máximo 8MB cada uno y
                    estar en formato:{" "}
                    <span className="font-bold">
                      .csv, .xls, .pdf, .png, .doc o .jpg.
                    </span>
                  </p>
                </div>
              </div>
              <h3 className="mb-2 text-lg font-bold text-[#615CB7]">
                Información general
              </h3>
              <p className="text-sm font-medium text-[#4F5D6D]">Tipo*</p>
              <DropdownMenu
                open={isDropdownOpen}
                onOpenChange={setIsDropdownOpen}
              >
                <DropdownMenuTrigger>
                  <div
                    className={cn(
                      "flex cursor-pointer items-center justify-between rounded-2xl border border-[#A0ACBA] px-3 text-sm transition-all duration-300 ease-in-out hover:bg-[rgba(192,192,192,0.1)]",
                    )}
                    style={{ height: "50px" }}
                  >
                    <p>{getSelectedType() ?? "Selecciona"}</p>

                    <ArrowDown2 size="20" color="#4F5D6D" />
                  </div>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="mr-6 mt-1 max-h-80 overflow-y-scroll rounded-xl p-0">
                  {typesFilters.map((option, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedType(option.id);
                        setIsDropdownOpen(false);
                      }}
                      className={cn(
                        "flex cursor-pointer items-center justify-start gap-2 border-b-[#A0ACBA] pb-3 pl-3 pr-3 pt-3 transition-all duration-300 ease-in-out hover:bg-[rgba(192,192,192,0.1)]",
                        {
                          "border-b-[1px]": index !== typesFilters?.length - 1,
                        },
                      )}
                    >
                      <p className={cn("text-sm font-medium text-[#4F5D6D]")}>
                        {option.title}
                      </p>
                    </div>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
              <div className="mb-3 mt-6 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <h3 className="font-bold text-[#615CB7]">Recursos</h3>
                  <div className="flex h-6 w-6 items-center justify-center rounded-md bg-[#CBCAE8]">
                    <p className="text-xs font-medium">
                      {formatLessThan10(resources?.length)}
                    </p>
                  </div>
                </div>
                <div
                  className="flex cursor-pointer items-center gap-2 rounded-2xl border border-[#A0ACBA] bg-[#F0F2F4] px-5 py-2"
                  onClick={addResource}
                >
                  <Add style={{ color: "#293038" }} size={20} />
                  <p className="select-none text-sm font-medium text-[#293038]">
                    Añadir
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-5">
                {resources.map((item, index) => (
                  <AssignedResourceItem
                    key={index}
                    resource={item}
                    index={index}
                    setResources={setResources}
                    resources={resources}
                    formError={formError.resourcesErrors?.find(
                      (item: any) => item.index === index,
                    )}
                    generalFormError={formError}
                    setGeneralFormError={setFormError}
                  />
                ))}
              </div>
            </div>
            <div className="grid grid-cols-2 items-center gap-2 px-6 py-4">
              <Button
                onClick={() => {}}
                type="submit"
                variant="default"
                className="h-12 rounded-xl bg-[#262452]"
              >
                Crear carpeta
              </Button>
              <Button
                type="button"
                variant="secondary"
                className="color-[#293038] h-12 select-none rounded-xl border border-[#A0ACBA] font-medium"
                onClick={closeDrawer}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
};

export default MassiveUpload;
